const ANIMATION_DURATION = 300;

export const cubicInOut = (t) => {
  let tt = t * 2;
  // eslint-disable-next-line no-return-assign
  return (tt <= 1 ? tt * tt * tt : ((tt -= 2) * tt * tt) + 2) / 2;
};

const transition = ({
  from,
  to,
  duration = 3000,
  delay = 0,
  easing = cubicInOut,
  start = (v) => v,
  step = (v) => v,
  end = (v) => v
}) => {
  let value = from;
  let startTime = 0;
  let finished = false;
  const update = (timestamp) => {
    if (finished) {
      return;
    }
    if (!startTime) {
      startTime = timestamp;
      start(value);
    }
    const t = Math.min(Math.max(timestamp - startTime - delay, 0), duration) / duration;
    value = (easing(t) * (to - from)) + from;
    step(value);
    if (t === 1) {
      finished = true;
      end(value);
    }
  };
  return { update };
};

const proceedAnimation = (ref, timestamp) => {
  if (!ref.update) {
    return;
  }
  requestAnimationFrame(t => proceedAnimation(ref, t));
  ref.update(timestamp);
};

/* eslint-disable no-param-reassign */
export const animateHeight = (ref, from, to) => {
  ref.contentNode.style.height = `${from}px`;
  const step = v => {
    ref.contentNode.style.height = `${v}px`;
  };
  const end = () => {
    ref.update = null;
    ref.contentNode.style.height = '';
  };

  ref.update = transition({
    from,
    to,
    duration: ANIMATION_DURATION,
    step,
    end
  }).update;
  requestAnimationFrame(t => proceedAnimation(ref, t));
};

export const expand = (ref, className) => {
  ref.contentNode.classList.add(className);
  animateHeight(ref, 0, ref.contentNode.getBoundingClientRect().height);
};

export const collapse = (ref, className) => {
  const from = ref.contentNode.getBoundingClientRect().height;
  ref.contentNode.classList.remove(className);
  animateHeight(ref, from, 0);
};
/* eslint-enable no-param-reassign */
